export let peaceHandPoints = [
    {x:196.9,y:228.8},
    {x:196.7,y:225.2},
    {x:196.6,y:221.6},
    {x:196.3,y:218.0},
    {x:195.9,y:214.3},
    {x:195.5,y:210.7},
    {x:195.1,y:207.1},
    {x:194.7,y:203.5},
    {x:194.3,y:199.9},
    {x:194.3,y:196.3},
    {x:195.1,y:192.7},
    {x:196.7,y:189.5},
    {x:198.9,y:186.6},
    {x:201.7,y:184.3},
    {x:204.9,y:182.6},
    {x:208.4,y:181.6},
    {x:212.0,y:181.3},
    {x:215.6,y:181.7},
    {x:219.0,y:182.9},
    {x:221.9,y:184.3},
    {x:224.7,y:186.6},
    {x:226.9,y:189.5},
    {x:228.2,y:192.0},
    {x:227.8,y:188.4},
    {x:227.4,y:184.7},
    {x:227.0,y:181.1},
    {x:227.0,y:177.5},
    {x:227.9,y:174.0},
    {x:229.5,y:170.7},
    {x:231.7,y:167.9},
    {x:234.5,y:165.5},
    {x:237.6,y:163.8},
    {x:241.1,y:162.8},
    {x:244.8,y:162.5},
    {x:248.4,y:162.9},
    {x:251.8,y:164.0},
    {x:254.9,y:165.8},
    {x:257.6,y:168.3},
    {x:259.1,y:169.3},
    {x:258.4,y:165.7},
    {x:257.7,y:162.2},
    {x:257.1,y:158.6},
    {x:256.4,y:155.0},
    {x:255.7,y:151.4},
    {x:255.1,y:147.9},
    {x:254.4,y:144.3},
    {x:253.7,y:140.7},
    {x:253.1,y:137.2},
    {x:252.4,y:133.6},
    {x:251.8,y:130.0},
    {x:251.1,y:126.5},
    {x:250.4,y:122.9},
    {x:249.8,y:119.3},
    {x:249.1,y:115.7},
    {x:248.4,y:112.2},
    {x:247.8,y:108.6},
    {x:247.1,y:105.0},
    {x:246.4,y:101.5},
    {x:245.8,y:97.9},
    {x:245.7,y:94.3},
    {x:246.5,y:90.7},
    {x:248.1,y:87.5},
    {x:250.3,y:84.6},
    {x:253.1,y:82.2},
    {x:256.3,y:80.5},
    {x:259.7,y:79.6},
    {x:263.2,y:79.2},
    {x:265.9,y:79.2},
    {x:269.4,y:80.1},
    {x:272.6,y:81.7},
    {x:275.4,y:84.1},
    {x:277.6,y:87.0},
    {x:279.1,y:90.2},
    {x:280.1,y:93.7},
    {x:280.7,y:97.3},
    {x:281.4,y:100.9},
    {x:282.1,y:104.4},
    {x:282.8,y:108.0},
    {x:283.4,y:111.6},
    {x:284.1,y:115.1},
    {x:284.8,y:118.7},
    {x:285.5,y:122.3},
    {x:286.1,y:125.8},
    {x:286.8,y:129.4},
    {x:287.5,y:133.0},
    {x:288.2,y:136.6},
    {x:288.8,y:140.1},
    {x:289.5,y:143.7},
    {x:290.2,y:147.3},
    {x:290.9,y:150.8},
    {x:291.5,y:154.4},
    {x:292.2,y:158.0},
    {x:292.9,y:161.5},
    {x:293.6,y:165.1},
    {x:294.3,y:168.7},
    {x:294.9,y:172.2},
    {x:295.6,y:175.8},
    {x:296.3,y:179.4},
    {x:297.0,y:182.9},
    {x:297.6,y:186.5},
    {x:298.3,y:190.1},
    {x:299.1,y:187.5},
    {x:299.9,y:184.0},
    {x:300.8,y:180.4},
    {x:301.6,y:176.9},
    {x:302.4,y:173.3},
    {x:303.2,y:169.8},
    {x:304.1,y:166.3},
    {x:304.9,y:162.7},
    {x:305.7,y:159.2},
    {x:306.5,y:155.7},
    {x:307.3,y:152.1},
    {x:308.2,y:148.6},
    {x:309.0,y:145.0},
    {x:309.8,y:141.5},
    {x:310.6,y:138.0},
    {x:311.5,y:134.4},
    {x:312.3,y:130.9},
    {x:313.1,y:127.4},
    {x:313.9,y:123.8},
    {x:314.8,y:120.3},
    {x:315.6,y:116.8},
    {x:316.4,y:113.2},
    {x:317.2,y:109.7},
    {x:318.0,y:106.1},
    {x:318.9,y:102.6},
    {x:319.7,y:99.1},
    {x:320.5,y:95.5},
    {x:321.5,y:92.0},
    {x:323.1,y:88.8},
    {x:325.5,y:86.1},
    {x:328.4,y:83.9},
    {x:331.6,y:82.3},
    {x:335.2,y:81.4},
    {x:338.8,y:81.2},
    {x:342.4,y:81.8},
    {x:345.7,y:83.1},
    {x:348.7,y:84.6},
    {x:351.6,y:86.9},
    {x:353.8,y:89.7},
    {x:355.2,y:93.1},
    {x:355.7,y:96.7},
    {x:355.6,y:100.3},
    {x:354.9,y:103.9},
    {x:354.1,y:107.4},
    {x:353.3,y:110.9},
    {x:352.4,y:114.5},
    {x:351.6,y:118.0},
    {x:350.8,y:121.5},
    {x:350.0,y:125.1},
    {x:349.2,y:128.6},
    {x:348.3,y:132.2},
    {x:347.5,y:135.7},
    {x:346.7,y:139.2},
    {x:345.9,y:142.8},
    {x:345.0,y:146.3},
    {x:344.2,y:149.8},
    {x:343.4,y:153.4},
    {x:342.6,y:156.9},
    {x:341.8,y:160.5},
    {x:340.9,y:164.0},
    {x:340.1,y:167.5},
    {x:339.3,y:171.1},
    {x:338.5,y:174.6},
    {x:337.7,y:178.1},
    {x:336.8,y:181.7},
    {x:336.0,y:185.2},
    {x:335.2,y:188.8},
    {x:334.4,y:192.3},
    {x:333.5,y:195.8},
    {x:332.7,y:199.4},
    {x:331.9,y:202.9},
    {x:331.1,y:206.4},
    {x:332.7,y:208.8},
    {x:335.9,y:210.6},
    {x:338.9,y:212.6},
    {x:341.6,y:215.0},
    {x:343.8,y:217.9},
    {x:345.6,y:221.1},
    {x:347.0,y:224.4},
    {x:348.2,y:227.8},
    {x:349.2,y:231.3},
    {x:350.0,y:234.9},
    {x:350.7,y:238.4},
    {x:351.1,y:242.0},
    {x:351.4,y:245.6},
    {x:351.5,y:249.3},
    {x:351.3,y:252.9},
    {x:350.9,y:256.5},
    {x:350.2,y:260.1},
    {x:349.2,y:263.6},
    {x:348.0,y:267.0},
    {x:346.8,y:270.4},
    {x:345.4,y:273.8},
    {x:343.9,y:277.1},
    {x:342.5,y:280.4},
    {x:341.0,y:283.7},
    {x:339.4,y:287.0},
    {x:336.9,y:289.5},
    {x:334.7,y:292.5},
    {x:332.5,y:295.3},
    {x:330.1,y:298.0},
    {x:327.5,y:300.6},
    {x:324.8,y:303.0},
    {x:322.0,y:305.3},
    {x:319.1,y:307.5},
    {x:316.0,y:309.4},
    {x:312.9,y:311.2},
    {x:309.6,y:312.9},
    {x:306.3,y:314.4},
    {x:302.9,y:315.7},
    {x:299.5,y:316.8},
    {x:296.0,y:317.8},
    {x:292.5,y:318.7},
    {x:288.9,y:319.4},
    {x:285.3,y:320.0},
    {x:281.7,y:320.4},
    {x:278.1,y:320.7},
    {x:274.5,y:320.9},
    {x:270.8,y:321.0},
    {x:267.2,y:320.8},
    {x:263.6,y:320.6},
    {x:260.0,y:320.2},
    {x:256.4,y:319.6},
    {x:252.8,y:318.8},
    {x:249.3,y:318.0},
    {x:245.8,y:316.9},
    {x:242.4,y:315.7},
    {x:239.0,y:314.4},
    {x:235.7,y:312.9},
    {x:232.5,y:311.3},
    {x:229.3,y:309.5},
    {x:226.3,y:307.5},
    {x:223.3,y:305.4},
    {x:220.6,y:303.0},
    {x:217.9,y:300.5},
    {x:215.5,y:297.8},
    {x:213.3,y:294.9},
    {x:211.3,y:291.9},
    {x:209.5,y:288.7},
    {x:207.9,y:285.5},
    {x:206.5,y:282.1},
    {x:205.2,y:278.8},
    {x:204.0,y:275.3},
    {x:202.9,y:271.9},
    {x:202.0,y:268.4},
    {x:201.1,y:264.8},
    {x:200.3,y:261.3},
    {x:199.6,y:257.7},
    {x:199.0,y:254.1},
    {x:198.4,y:250.6},
    {x:198.0,y:247.0},
    {x:197.6,y:243.3},
    {x:197.4,y:239.7},
    {x:197.3,y:236.1},
    {x:197.1,y:232.5},
]